import axios from "axios";

export async function fetchTargetCategoriesWithPupils() {
    try {
        // Получаем все категории
        const categoriesResponse = await axios.get("/categories");
        const allCategories = categoriesResponse.data.categories;
        
        // Фильтруем только целевые группы
        const targetCategories = allCategories.filter(cat => cat.type === "target");
        
        // Получаем всех учеников с категориями ОДИН РАЗ
        const pupilsResponse = await axios.get("/pupil/with-categories");
        const allPupils = pupilsResponse.data;
        
        // Для каждой целевой группы считаем количество учеников
        const categoriesWithPupils = targetCategories.map((category) => {
            const pupilsCount = allPupils.filter(pupil => 
                pupil.categories.some(cat => cat._id === category._id)
            ).length;
            
            return {
                _id: category._id,
                title: category.title,
                type: category.type,
                pupilsCount,
            };
        });
        
        // Сортируем по количеству учеников (от большего к меньшему), затем по названию
        return categoriesWithPupils.sort((a, b) => {
            if (b.pupilsCount !== a.pupilsCount) {
                return b.pupilsCount - a.pupilsCount;
            }
            return a.title.localeCompare(b.title);
        });
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка загрузки целевых групп";
        throw new Error(text);
    }
}
